import { Box, Container, Fade, Flex, Text } from "@chakra-ui/react";
import { FC } from "react";
import { useParams } from "react-router-dom";

import {
  Banner,
  CustomedSpinner,
  PageHeader,
} from "../../shared/components";
import bannerImage from "../../img/bannerTv/telew_top.jpg";
import { BannerClass } from "../../shared/components/Banner/utils";
import { useUserData } from "../../hooks/useUserData";
import { env } from "../../env";
import { useGponDetails } from "../../hooks/useGponDetails";
import { formatClock, timestampToDateString } from "../../shared/utils";

export const FiberDevice: FC = () => {
  const { id } = useParams();
  const { data, isLoading } = useGponDetails(id?.toString() || "");
  const userData = useUserData();

  const {
    // profileData,
    serialNumber,
    receiverPower,
    deactivateReason,
    modelName,
    macAddress,
    status,
    historyDate,
    ports,
    protocol,
    wifiSsid,
    wifiPassword
  } = data;


  const bannerDetails = new BannerClass(env.REACT_APP_USE_USER_CODE === 'true' ? userData.data?.usercode : userData.data?.userno);

  if (isLoading) {
    return <CustomedSpinner />;
  }

  return (
    <>
      <Banner bannerImage={bannerImage} {...bannerDetails} />
      <Fade in={true}>
        <Container maxWidth={"container.xl"} flexDir={"column"}  >
          <PageHeader title={modelName} buttonText="Urządzenia" />
          <Box
            bg="white"
            p={6}
            mt={6}
            borderRadius="md"
            // boxShadow="md"
            width="100%"
          >
            <Box mb={3}>
              <Text fontWeight="semibold">Model</Text>
              {/* <Text>{profileData?.name || 'Brak'}</Text> */}
              <Text>{modelName || 'Brak'}</Text>
            </Box>

            <Box mb={3}>
              <Text fontWeight="semibold">MAC</Text>
              <Text>{macAddress || 'Brak'}</Text>
            </Box>

            <Box mb={3}>
              <Text fontWeight="semibold">Numer seryjny</Text>
              <Text>{serialNumber || 'Brak'}</Text>
            </Box>

            <Box mb={3}>
              <Text fontWeight="semibold">Konfiguracja</Text>
              <Text>{protocol.toUpperCase() || 'Brak'}</Text>
            </Box>

            {
              (protocol !== 'bridge' && wifiSsid && wifiPassword) ? (
                <>
                  <Box mb={3}>
                    <Text fontWeight="semibold">SSID</Text>
                    <Text>{wifiSsid || 'Brak'}</Text>
                  </Box>
                  <Box mb={3}>
                    <Text fontWeight="semibold">Hasło</Text>
                    <Text>{wifiPassword || 'Brak'}</Text>
                  </Box>
                </>
              ) : null
            }

            <Box mb={3}>
              <Text fontWeight="semibold">Moc odbioru</Text>
              <Text>{receiverPower ? receiverPower + ' dBm' : 'Brak mocy'}</Text>
            </Box>

            <Box mb={3}>
              <Text fontWeight="semibold">Status</Text>
              <Text>{status || 'Brak'}</Text>
            </Box>

            <Box mb={3}>
              <Text fontWeight="semibold">Ostatni powód dezaktywacji</Text>
              <Text>{deactivateReason ? (deactivateReason === 'dgi' ? "Utrata zasilania. Sprawdź kabel" : 'Utrata sygnału światłowodowego') : 'Brak'}</Text>
            </Box>
            <Box mb={3}>
              <Text fontWeight="semibold">Odczytano</Text>
              <Text>{historyDate ? timestampToDateString(Number(historyDate) * 1000) + ' ' + formatClock(Number(historyDate) * 1000) : 'Brak daty'}</Text>
            </Box>

            <Box mb={3}>
              <Text fontWeight="semibold" mb={1}>Porty</Text>
              {ports && Object.keys(ports).length ? (
                <Box pl={0}>
                  <Flex wrap="wrap" gap={4}>

                    {Object.entries(ports).map(([port, details]: any) => (
                      <Box key={port} mb={3} mr={3} border={'1px solid'} minW={'160px'} p={3} borderRadius={'md'} borderColor={'gray.200'}>
                        <Text fontWeight="medium">Port {port}</Text>
                        <Text fontSize="sm">Usługa: {details.service}</Text>
                      </Box>
                    ))}
                  </Flex>
                </Box>
              ) : (
                <Text>Brak danych o portach</Text>
              )}
            </Box>

          </Box>
        </Container>
      </Fade >
    </>
  );
};
